<template>
  <div>
    <el-carousel trigger="click" height="590px" :interval="5000">
      <el-carousel-item :key="1" style="text-align: center">
        <!-- <h3 class="small">{{ item }}</h3> -->
        <img style="margin: 25px 0" width="900" height="540" src="https://biobigdata.nju.edu.cn/scplantdb/static/home_carousel/testInterval1.png">
      </el-carousel-item>
      <el-carousel-item :key="2" style="text-align: center">
        <!-- <h3 class="small">{{ item }}</h3> -->
        <img style="margin: 25px 0" width="900" height="540" src="https://biobigdata.nju.edu.cn/scplantdb/static/home_carousel/testInterval2.png">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {

}
</script>

<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 450px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: white;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6aa;
  }
</style>